import { ActionFunction, redirect } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { parseFormData } from "../../utils/parseFormData";
import { ExamTypeCategory } from "./type";

export const examTypeCategoryAction: ActionFunction = async (
  { request, params },
  context
) => {
  const formData = await request.formData();
  const updates = parseFormData(formData);
  if (params.examTypeCode === "new") {
    const result = await axiosApi.post<Result<ExamTypeCategory>>(
      "/api/examTypeCategories",
      updates
    );
    return redirect(
      `/examTypeCategories/${params.examTypeCode}/${result.data.data?.categoryCode}`
    );
  } else await axiosApi.put("/api/examTypeCategories", updates);
  return redirect(`/examTypeCategories/${params.examTypeCode}`);
};
